/* eslint-disable */
import React, { useMemo, useState } from 'react';

import { CTitle, STitle } from '../../components/Widget';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
import Quiz from '../../components/Quiz';
import ToolsBox from '../../components/ToolsBox';
import RegressionTop from '../../../../../../assets/cybersecurity2026/topic1600/regression_top.png';
import RegressionBottom from '../../../../../../assets/cybersecurity2026/topic1600/regression_bottom.png';
import { useUpdateComponentState } from '../../../hooks';
import arrow from '../../../../../../assets/cybersecurity2026/finger.gif';
interface ISection0Props {
  settings: any;
}

const Section4: React.FunctionComponent<ISection0Props> = ({ settings }) => {
  const ID = '5';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[4],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  const { quiz } = paragraphsSettings;
  const { updateParagraphState } = useStore();
  const [quizState, setQuizState] = useState(false);
  const [visibleCount, setVisibleCount] = useState(1); // 默认显示第一条
  const [animationStarted, setAnimationStarted] = useState(false); // 控制
  const quizComplete = () => {
    setQuizState(true);
  };
  // 点击箭头图标时触发动画
  const handleArrowClick = () => {
    if (!animationStarted) {
      setAnimationStarted(true);
      // 从第二条开始显示（第一条已经显示）
      setVisibleCount(2);
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'cybersecurity2026-topic1600-section4-2'
      );
    }
  };
  React.useEffect(() => {
    if (quizState) {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'cybersecurity2026-topic1600-section4-question'
      );
    }
  }, [p_course, p_topic, quizState]);
  React.useEffect(() => {
    // 如果动画还未开始，则不自动播放
    if (!animationStarted) return;

    // 如果已经显示完所有项目，则停止
    if (visibleCount >= paragraphsSettings.risks?.length) return;

    const timer = setTimeout(() => {
      setVisibleCount((v) => v + 1);
    }, 600);

    return () => clearTimeout(timer);
  }, [visibleCount, animationStarted, paragraphsSettings.risks?.length]);
  const handleComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'cybersecurity2026-topic1600-section4-1'
    );
  }, [updateComponentState, p_course, p_topic, ID]);
  return (
    <div className="topic-section-4">
      <CTitle title={paragraphsSettings?.title} />
      <ToolsBox
        title={paragraphsSettings?.toolTitle}
        leftText={paragraphsSettings?.l3}
        rightText={paragraphsSettings?.l4}
        leftBackgroundImage={RegressionTop}
        rightBackgroundImage={RegressionBottom}
        id="cybersecurity2026-topic1600-section4-1"
        onComplete={handleComplete}
      />
      <div className="tampering">
        <STitle title={paragraphsSettings?.responseTips} />
        <i className="back_piece"></i>
        <div className="content" id="cybersecurity2026-topic1600-section4-2">
          {!animationStarted && (
            <img className="arrow-img" src={arrow} alt="" />
          )}
          <div className="left-list">
            {paragraphsSettings.risks?.map((r: any, i: number) => (
              <div
                key={i}
                className="risk-item"
                data-show={i < visibleCount}
                onClick={i === 0 ? handleArrowClick : undefined}
                style={{
                  cursor: i === 0 && !animationStarted ? 'pointer' : 'default',
                }}
              >
                <div className="risk-title">
                  <h5>{r.num}</h5>
                  <span>{r.title}</span>
                </div>
                <div className="risk-desc">
                  <div className="risk-desc-box">
                    {r.arr?.map((rsub: any, i: number) => (
                      <div key={i} className="risk-desc-text">
                        <span>{i + 1}.</span>
                        {rsub}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div
        id="cybersecurity2026-topic1600-section4-question"
        className="topic-quiz"
      >
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={quiz?.description}
          question={quiz?.question}
          options={quiz?.options}
          onCompleted={quizComplete}
        />
      </div>
    </div>
  );
};

export default React.memo(Section4);
